const UNSUPPORTED_SDP_LINE_PREFIXES = Object.freeze([
  "a=max-message-size:",
]);

const shouldKeepSdpLine = (line) =>
  !UNSUPPORTED_SDP_LINE_PREFIXES.some((prefix) => line.startsWith(prefix));

export const sanitizeSessionDescriptionSdp = (sdp = "") =>
  sdp
    .split("\r\n")
    .filter(shouldKeepSdpLine)
    .join("\r\n");

export const normalizeSessionDescription = (description) => ({
  type: description.type,
  sdp: sanitizeSessionDescriptionSdp(description.sdp),
});
